<template id="limitare">
  <base-page>
  <el-card style="margin: 5px 0px 5px 0px">
  <titlu-pagina
                Titlu="Limitare programari"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
              </el-card>
  
    <el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px"></el-table-column>
      <el-table-column prop="Denumire" label="Denumire"></el-table-column>
      <el-table-column prop="Email" label="Email"></el-table-column>
      <el-table-column align="center" prop="LimitaZi" label="Limita / Zi"></el-table-column>
      <el-table-column prop="NumeCentru" label="Centru productie"></el-table-column>
      <el-table-column fixed="right"  label="Actiuni" width="350px">
        <template slot-scope="scope" >
            <el-date-picker
            
            popper-class="picker-limitare"
            type="dates"
            value-format="yyyy-MM-dd"
            v-model="limitariRegula"
            style="display: none" ref="refDataCurs"
            :picker-options="{
              firstDayOfWeek: 1,
            }"

            placeholder="Pick one or more dates">
          </el-date-picker>
            <el-tooltip content="Arata zilele limitate">
              <el-button
                type="success"
                icon="el-icon-view"
                circle size="small"
                @click="show_dialog_calendar(scope.row)"
              />
            </el-tooltip>

          <el-tooltip content="Modificare">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle size="small"
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle size="small"
              @click="delete_item(scope.row)"
            /> 
          </el-tooltip>
        </template>
      </el-table-column
    ></el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager" />
    <Limitare-rezervari-dialog class="custom-width" ref="dlg" @save="refresh_info()"/>
    <!-- <Limitare-rezervari-calendar-dialog class="custom-width" ref="dlg_calendar" /> -->
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Limitare_rezervari_dialog from "@/pages/Admin/limitare_rezervari/Limitare_rezervari_dialog.vue";
// import Limitare_rezervari_calendar_dialog from "@/pages/Admin/limitare_rezervari/Limitare_rezervari_calendar_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "marci_masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Limitare-rezervari-dialog": Limitare_rezervari_dialog,
    // "Limitare-rezervari-calendar-dialog": Limitare_rezervari_calendar_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      limitariRegula:[],
      Results: [],
      base_url: "",
      Info: {},
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },

  
  methods: {
    async get_info() {
      var response = await this.post("rezervari_limitare/get_info");
      this.Info.utilizatori = response.utilizatori;
     this.refresh_info();
    },


    async refresh_info() {
      var response = await this.post("rezervari_limitare/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("rezervari_limitare");
    },
    reset() {
      this.Filters = {
        Denumire: "",
        Data: [],
        IdUtilizator: "-1",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("rezervari_limitare/delete_item", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },    
    async show_dialog_calendar(row) {

      if(row.LimitaZi == 0){
        this.$message({type: 'info', message: 'Limita este 0. Toate zilele sunt blocate!'});
        return;
      }

      var result = await this.post("rezervari_limitare/get_zile_limitate", {idLimitare: row.Id  });

      if (result.limitari){
        this.limitariRegula = result.limitari;
      }
      this.$refs['refDataCurs'].pickerVisible = true;
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped >


// /deep/ .el-date-table td.selected span {
//         background-color: red !important;
//       }
    
  





.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 31%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }  


}
</style>
